// Splash potion (MB.6). PURE (ENG-1). A witch's thrown splash potion; flies with
// the shared arrow integrator and, unlike an arrow, does not stick — it shatters
// on the first block/entity/ground contact into an area cloud (see
// EntitySystem.tickProjectiles → shatterPotion + game/potion.splashBurst). The
// `effect` payload names the potion's effect + its full (unscaled) duration.
import { POTION } from '../../config';
import type { Entity, EntitySystem, Projectile } from '../entity';
import { solveAim } from './shared';

/** Throw a splash potion from `shooter` toward (tx,ty,tz), carrying `effect`. */
export function throwSplashPotionAt(
  sys: EntitySystem,
  shooter: Entity,
  tx: number,
  ty: number,
  tz: number,
  effect: NonNullable<Projectile['effect']>,
): void {
  const sx = shooter.x, sy = shooter.y + 1.2, sz = shooter.z;
  const v = solveAim(tx - sx, ty - sy, tz - sz, POTION.THROW_SPEED);
  sys.spawnProjectile('potion', sx, sy, sz, v.x, v.y, v.z, shooter.id, 0, effect);
}
